<template>
    <el-drawer :title="isedit ? '编辑道闸' : '新增道闸'" :visible.sync="childdialogshow" :show-close="false"
        :destroy-on-close="true" :wrapperClosable="false" direction="rtl" ref="drawer" :size="getViewWidth()"
        :before-close="cancel">
        <div class="dialogshow">
            <div class="dialoForm-content">
                <el-form class="dialoForm-form" ref="createform" :model="createform" label-width="120px" :rules="rules"
                    style="width: 95%">
                    <el-form-item label="启用状态：">
                        <el-switch style="width: 100%" v-model="createform.EnableMark"></el-switch>
                    </el-form-item>
                    <el-form-item label="道闸名称" label-width="120px" prop="BarrierGateName">
                        <el-input v-model="createform.BarrierGateName" maxlength="20" show-word-limit
                            autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="道闸SN" label-width="120px" prop="BarrierGateSn">
                        <el-input v-model="createform.BarrierGateSn" maxlength="20" show-word-limit
                            autocomplete="off"></el-input>
                    </el-form-item>

                    <el-form-item label="道闸品牌：" label-width="120px" prop="BarrierGateType">
                        <el-select style="width: 100%" v-model="createform.BarrierGateBrand" placeholder="请选择道闸类型">
                            <el-option label="芊熠四行屏" value="QY04"></el-option>
                            <el-option label="臻识两行屏" value="ZS02"></el-option>
                            <el-option label="臻识四行屏" value="ZS04"></el-option>
                            <el-option label="臻识四行屏KL" value="ZSKL"></el-option>
                            <el-option label="华夏四行屏" value="HX04"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="道闸类型：" label-width="120px" prop="BarrierGateType">
                        <el-select style="width: 100%" v-model="createform.BarrierGateType" placeholder="请选择道闸类型">
                            <el-option label="入口道闸" :value="1"></el-option>
                            <el-option label="出口道闸" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属路段：" prop="SectionId">
                        <el-select style="width: 100%" v-model="createform.SectionId" prop="SectionId"
                            placeholder="请选择所属路段">
                            <el-option v-for="item in sectionlist" :key="item.Id" :label="item.SectionName"
                                :value="item.Id"></el-option>
                        </el-select>
                    </el-form-item>
                 
                    
                    <el-form-item v-if="createform.BarrierGateType == 1" label="月卡通道：">
                        <el-switch style="width: 20%" v-model="createform.NoPassMonthCardMark"></el-switch>开启后可仅月卡车可驶入。
                    </el-form-item>
                </el-form>
            </div>
            <div class="dialoForm-footer">
                <!-- <el-button @click="open" type="warning" style="width: 100px">开闸</el-button> -->
                <!-- <el-button @click="close" type="danger" style="width: 100px">关闸</el-button> -->
                <el-button @click="cancel" style="width: 100px">取 消</el-button>
                <el-button style="width: 100px" type="primary" @click="save">保 存</el-button>
            </div>
        </div>
    </el-drawer>
</template>
<script>
import { createbarriergate, editbarriergate, dzcmd } from "@/api/barriergate";
export default {
    name: "addbarriergate",
    props: {
        isedit: {
            required: true,
            type: Boolean,
        },
        dialogshow: {
            required: true,
            type: Boolean,
        },
        editform: {
            required: true,
            type: Object,
        },
        sectionlist: {
            required: true,
            type: Array,
        }
    },
    computed: {
        childdialogshow: {
            get() {
                return this.dialogshow;
            },
            set(val) {
                this.$emit("update:dialogshow", val);
            },
        },
        createform: {
            get() {
                return this.editform;
            },
        },
    },
    data() {
        return {
            sectionlist: [],
            rules: {
                BarrierGateName: [
                    { required: true, message: "道闸名称不能为空", trigger: "blur" },
                    {
                        max: 20,
                        message: "道闸名称长度不超过20，请重新输入",
                        trigger: "blur",
                    },
                ],
                BarrierGateSn: [
                    { required: true, message: "道闸编号不能为空", trigger: "blur" },
                    {
                        max: 20,
                        message: "道闸编号长度不超过20，请重新输入",
                        trigger: "blur",
                    },
                ],
                BarrierGateType: [
                    { required: true, message: "道闸类型不能为空", trigger: "blur" },
                ],
                SectionId: [
                    { required: true, message: "所属路段不能为空", trigger: "blur" },
                ],
            },
        };
    },
    methods: {
        open() {
            dzcmd({ sn: this.createform.BarrierGateSn, cmd: "1" }).then(res => {
            })
        },
        close() {
            dzcmd({ sn: this.createform.BarrierGateSn, cmd: "2" }).then(res => {
            })
        },
        save() {
            this.$refs.createform.validate((valid) => {
                if (valid) {
                    if (!this.isedit) {
                        createbarriergate(this.createform).then((res) => {
                            this.$message({
                                message: "新增道闸成功！",
                                type: "success",
                            });
                            this.childdialogshow = false;
                            this.$emit("savecomplete", res);
                        });
                    } else {
                        editbarriergate(this.createform).then((res) => {
                            this.$message({
                                message: "保存成功！",
                                type: "success",
                            });
                            this.childdialogshow = false;
                            this.$emit("savecomplete");
                        });
                    }
                }
            });
        },
        cancel() {
            this.$emit("cancelcomplete");
        },
    },
};
</script>